import { render, staticRenderFns } from "./ConferenceIndex.vue?vue&type=template&id=1127d132&scoped=true&"
import script from "./ConferenceIndex.vue?vue&type=script&lang=js&"
export * from "./ConferenceIndex.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceIndex.vue?vue&type=style&index=0&id=1127d132&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127d132",
  null
  
)

export default component.exports